module.exports = __webpack_public_path__ + "static/media/fly0100.dbc9310b.webp";